
<div style="background-color: HSL(225, 40%, 98%);" class="mt-5 pt-5">
    <header class="pl-5 pr-4 container pb-2">
        <div class="d-flex align-items-center mt-3">
            <h1 class="headline-4 pis">Merchandise</h1>
            <div class="card__right-side d-flex justify-content-end search ml-auto">
                <div class="search__icon-wrapper"><i  class="fas fa-search input-prefix"></i>
                </div>
                <input [formControl]="search" placeholder="Search merchandise..." class="form-control--search body-2 ng-untouched ng-pristine ng-valid">
                <div class="search__icon-wrapper--cross px-1"><!----></div>
            </div>
        </div>
        @if(merchandiseCampaigns?.length > 0){
            <span class="grey-text subtitle-2">You have a total of <b  class="black-text"> {{merchandiseCampaigns?.length}} campaigns </b>
            </span>
        }
    </header>
</div>

<div class="py-5 pl-5 pr-4 container" style="background-color: HSL(225, 40%, 98%);">
    @for(campaign of filteredMerchandiseCampaigns; track campaign.id){
        <app-merchandise-card [selectedMerchandise]="campaign"></app-merchandise-card>
    }
    
    @if(!merchandiseCampaigns || merchandiseCampaigns.length === 0){
        <div class="text-center p-3">No merchandise campaigns yet.</div>
    }
    @else if(!filteredMerchandiseCampaigns || filteredMerchandiseCampaigns.length === 0){
        <div class="text-center p-3">No matching merchandise campaigns.</div>
    }
    
</div>